import { get, writable } from 'svelte/store';
import { CustomerService } from '../../services/customer.service';
export const loading = writable(false);
export const records = writable([]);
export const record = writable(null);
export async function initList(customerId) {
    record.set(null);
    await load(customerId);
}
export async function load(customerId) {
    loading.set(true);
    try {
        let _resp = await CustomerService.getCustomerAddresses(customerId);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate(customerId) {
    let _recs = get(records);
    let main = customerId > 0 && _recs != null && _recs.length == 0 ? true : false;
    record.set({
        oid: 0,
        customerId: customerId,
        headquarters: main ? 1 : 0,
        description: main ? "Principale" : "",
        street: '',
        civicNumber: '',
        city: '',
        province: '',
        country: '',
        zipCode: ''
    });
}
export function onEdit(item) {
    record.set(item);
}
export async function save() {
    let _record = get(record);
    return await CustomerService.saveCustomerAddress(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await CustomerService.deleteCustomerAddress(item.oid);
    await load(item.customerId);
}
